<template>
  <div
    v-if="config.filters.fields && config.filters.fields.length"
    :style="`overflow-y:auto;max-height:${(windowWidth < 960 ? windowHeight/2 :windowHeight)-(config.hideTextFilter ? 0 : 48)-36}px`"
  >
    <v-treeview
      selectable
      dense
      :load-children="fetchFiltersValues"
      :items="items"
      @input="refresh"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { filters2qs } from '@data-fair/components-app/filters/filters'
import axios from 'axios'

export default {
  data: () => ({
    items: []
  }),
  computed: {
    ...mapState(['dataset', 'loading', 'filters', 'filtersValues']),
    ...mapGetters(['config', 'datasetUrl', 'fields'])
  },
  watch: {
    filtersValues () {
      this.initFilters()
    }
  },
  mounted () {
    this.initFilters()
  },
  methods: {
    label (key) {
      const field = this.fields[key]
      if (!field) return key
      return field.title || field['x-originalName'] || key
    },
    initFilters () {
      const rootField = this.config.filters.fields[0]
      if (this.filtersValues[rootField]) this.items = this.filtersValues[rootField].map(fv => ({ id: rootField + '---' + fv.value, name: fv.text, children: (this.config.filters.fields.length > 1) ? [] : undefined, depth: 0 }))
    },
    async fetchFiltersValues (item) {
      const field = this.config.filters.fields[item.depth + 1]
      if (!field) return
      const labels = this.fields[field]['x-labels']
      const params = { field, agg_size: 1000, sort: field }
      params.qs = item.id.replace('---', ':"') + '"'
      if (this.config.staticFilters && this.config.staticFilters.length) {
        params.qs += (params.qs.length ? ' AND ' : '') + filters2qs(this.config.staticFilters)
      }
      if (!params.qs.length) delete params.qs
      return axios.get(this.datasetUrl + '/values_agg', { params }).then(res => {
        item.children.push(...res.data.aggs.map(a => ({ id: field + '---' + a.value, name: (labels ? labels[a.value] : a.value) + ` (${a.total})`, depth: item.depth + 1, children: (this.config.filters.fields.length > item.depth + 2) ? [] : undefined })))
      })
    },
    refresh (items) {
      const filters = {}
      this.config.filters.fields.forEach(f => { filters[f] = [] })
      items.forEach(item => {
        const [field, value] = item.split('---')
        filters[field].push(value)
      })
      this.$store.commit('setAny', { filters })
      this.$store.dispatch('refresh', true)
    }
  }
}
</script>
